import React from 'react';
import Link from 'gatsby-link';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import MarvelLink from '@marvelapp/marvel-ui/link';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ArrowRight from 'marketing-website/components/icons/ArrowRight';
import Close from 'marketing-website/components/icons/Close';
import Hamburger from 'marketing-website/components/icons/Hamburger';

import navLinks from 'marketing-website/configs/navLinks.js';
import { SIGNIN } from 'marketing-website/constants/urls';

import NavDropdown from './NavDropdown';
import NavButton from './NavButton';
import NavLink from './NavLink';

import desktopStyles from './style/desktop.module.css';
import mobileStyles from './style/mobile.module.css';
import triggerStyles from './style/trigger.module.css';
import MobileSecondaryNav from './MobileSecondaryNav';

const cx = classNames.bind({ ...mobileStyles });

export default class HeaderNav extends React.Component {
  state = {
    currentlyOpenSecondaryNav: '',
  };

  setCurrentlyOpenSecondaryNav = secondaryNavTitle => {
    this.setState({ currentlyOpenSecondaryNav: secondaryNavTitle });
  };

  render() {
    const {
      isLight,
      isNavOpen,
      isLoggedIn,
      showFullForm,
      toggleNav,
    } = this.props;

    const linkType = isLight ? 'opaqueReversed' : 'licoriceToBlue';
    const fillColor = isLight ? 'fill-white' : 'fill-black';

    const triggerFillColor = cx('textAlign-right', {
      'fill-black': isNavOpen,
      [fillColor]: !isNavOpen,
    });

    const renderDesktopNav = (
      <div className={desktopStyles.nav}>
        <InlineGrid>
          {navLinks.map(item => {
            switch (item.type) {
              case 'dropdown':
                return (
                  <NavDropdown
                    key={item.id}
                    {...item}
                    linkType={linkType}
                    isLight={isLight}
                  />
                );
              case 'button':
                return (
                  <NavButton
                    key={item.id}
                    {...item}
                    isLight={isLight}
                    showFullForm={showFullForm}
                    linkType={linkType}
                    isLoggedIn={isLoggedIn}
                  />
                );
              default: {
                return (
                  !(item.url === SIGNIN && isLoggedIn) && (
                    <NavLink
                      {...item}
                      key={item.id}
                      linkType={linkType}
                      isLight={isLight}
                    />
                  )
                );
              }
            }
          })}
        </InlineGrid>
      </div>
    );
    const navClassName = cx('nav', {
      isOpen: isNavOpen,
    });

    const renderSecondaryNav = navLinks.map(
      item =>
        item.type === 'dropdown' && (
          <MobileSecondaryNav
            colHeading={item.title}
            currentlyOpen={this.state.currentlyOpenSecondaryNav}
            resetCurrentlyOpen={() => this.setCurrentlyOpenSecondaryNav('')}
            {...item}
          />
        )
    );

    const renderMobileNav = (
      <div className={navClassName}>
        <div className={cx('inner')}>
          {navLinks.map(item => (
            <Spacing type="margin" size="l" position="topBottom" key={item.id}>
              {item.type === 'dropdown' ? (
                <div
                  className={mobileStyles.link}
                  onClick={() =>
                    this.setCurrentlyOpenSecondaryNav(item.firstColumnHeading)
                  }
                >
                  {item.title}
                  <ArrowRight marginRight="0" color="licorice" />
                </div>
              ) : (
                <Link
                  className={mobileStyles.link}
                  to={item.url}
                  onClick={() => toggleNav()}
                >
                  <MarvelLink type="licoriceToBlue">{item.title}</MarvelLink>
                </Link>
              )}
            </Spacing>
          ))}
        </div>
        {renderSecondaryNav}
      </div>
    );

    return (
      <nav>
        {renderDesktopNav}
        {renderMobileNav}
        <div
          onClick={() => {
            toggleNav();
          }}
          className={triggerStyles.trigger}
        >
          <Spacing type="padding" size="s" position="topBottom">
            <div className={triggerFillColor}>
              {isNavOpen ? <Close /> : <Hamburger />}
            </div>
          </Spacing>
        </div>
      </nav>
    );
  }
}

HeaderNav.propTypes = {
  isNavOpen: PropTypes.bool.isRequired,
  isLight: PropTypes.bool,
  toggleNav: PropTypes.func.isRequired,
  showFullForm: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  testGroupNumber: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/modules/Header/HeaderNav/HeaderNav.js